/* themeReducer */
export const TOGGLE_THEME = "TOGGLE_THEME";

/* navReducer */
export const TOGGLE_NAV = "TOGGLE_NAV";

/* authReducer */
export const GET_TOKEN = "GET_TOKEN";
export const TOGGLE_SIGN_IN = "TOGGLE_SIGN_IN";
export const TOGGLE_LOGGED_IN = "TOGGLE_LOGGED_IN";
export const SIGN_IN_USER = "SIGN_IN_USER";
export const SIGN_OUT_USER = "SIGN_OUT_USER";
export const ADD_TO_FAVS = "ADD_TO_FAVS";
export const EDIT_USER = "EDIT_USER";
export const AUTH_ERROR = "AUTH_ERROR";

/* productReducer */
export const FETCH_PRODUCTS = "FETCH_PRODUCTS";
export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const EDIT_FROM_CART = "EDIT_FROM_CART";
export const EMPTY_CART = "EMPTY_CART";
export const SORT_PRODUCTS = "SORT_PRODUCTS";
export const EDIT_PRODUCT = "EDIT_PRODUCT";
export const ADD_PRODUCT = "ADD_PRODUCT";

/* orderReducer */
export const FETCH_ORDERS = "FETCH_ORDERS";

/* serverResReducer */
export const SET_RESPONSE_STATUS = "SET_RESPONSE_STATUS";
export const SET_RESPONSE_MESSAGE = "SET_RESPONSE_MESSAGE";
